var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      ref: "browse",
      attrs: {
        "data-source": _vm.dataSource,
        "clear-view-settings-filters": _vm.clearViewSettingsFilters,
        "allow-view-button": _vm.allowViewButton,
      },
    },
    [
      _vm._t(
        "browse-action-buttons",
        function () {
          return [
            _vm.bookYearSelect
              ? _c(
                  "div",
                  { staticClass: "bookyear-wrapper" },
                  [
                    _c("app-select-book-year", {
                      attrs: {
                        value: _vm.selectedBookYear,
                        "include-book-year0": "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onBookYearChange($event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        { slot: "browse-action-buttons" }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }